import script from "./auth-phone-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-phone-form.vue?vue&type=script&lang=ts&setup=true"

import "./auth-phone-form.vue?vue&type=style&index=0&id=1601b1e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1601b1e0"]])

export default __exports__